// extracted by mini-css-extract-plugin
module.exports = {"smart":"index_smart__XtA5q","smarttop":"index_smarttop__IvAwx","smartbottom":"index_smartbottom__o7VQq","smartbtmr":"index_smartbtmr__UZ_bE"};